// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
//商品
import Goods  from '@/views/goods/goods';
//菜单
import menu  from '@/views/system/menu';

import Status  from '@/views/system/status';
//用户管理
import user  from '@/views/system/user';
import belone  from '@/views/system/belong';
import provide  from '@/views/system/provide';
import project  from '@/views/system/project';
import meal  from '@/views/system/meal';
import Role  from '@/views/system/role';
import exportData from '@/views/datacenter/export';
import addOrder  from '@/views/order/addOrder';
import Order  from '@/views/order/order';
import admin  from '@/views/system/admin';
import password  from '@/views/setting/password';
import goods  from '@/views/system/goods';
import baiduOrder  from '@/views/order/baiduOrder';
// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [

         {
            path: '/system/goods',
            name: '商品管理',
            component: goods,
            meta: {
               requireAuth: true
                  }
           }, 
            {
                path: '/setting/password',
                name: '设置密码',
                component: password,
                meta: {
                   requireAuth: true
                      }
               }, 
               {
                  path: '/system/project',
                  name: '项目设置',
                  component: project,
                  meta: {
                     requireAuth: true
                        }
                 }, 
                 {
                  path: '/system/belong',
                  name: '归属地设置',
                  component: belone,
                  meta: {
                     requireAuth: true
                        }
                 }, 
                 {
                  path: '/system/provide',
                  name: '供应商设置',
                  component: provide,
                  meta: {
                     requireAuth: true
                        }
                 }, 
                 {
                  path: '/system/meal',
                  name: '套餐设置',
                  component: meal,
                  meta: {
                     requireAuth: true
                        }
                 }, 
                 {
                  path: '/system/status',
                  name: '状态设置',
                  component: Status,
                  meta: {
                     requireAuth: true
                        }
                 }, 
                 {
                  path: '/order/baiduorder',
                  name: '百度订单',
                  component: baiduOrder,
                  meta: {
                     requireAuth: true
                        }
                 }, 
             {
                path: '/order/addOrder',
                name: '添加订单',
                component: addOrder,
                meta: {
                   requireAuth: true
                      }
               }, 
               {
                path: '/order/Order',
                name: '订单列表',
                component: Order,
                meta: {
                   requireAuth: true
                      }
               },               
            {
                path: '/system/user',
                name: '管理业务员',
                component: user,
                meta: {
                   requireAuth: true
                      }
               },        
            {
            path: '/goods/Goods',
            name: '商品管理',
            component: Goods,
            meta: {
                requireAuth: true
            }
                },
            {
              path: '/system/menu',
              name: '菜单管理',
              component: menu,
              meta: {
                 requireAuth: true
                    }
             },
             {
                path: '/system/admin',
                name: '管理员',
                component: admin,
                meta: {
                   requireAuth: true
                      }
               },
             {
                path: '/system/role',
                name: '权限管理',
                component: Role,
                meta: {
                   requireAuth: true
                      }
               },
               {
                path: '/datacenter/export',
                name: '数据导出',
                component: exportData,
                meta: {
                   requireAuth: true
                      }
               },
             
            
                    ]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js